import { Search } from '@sainsburys-tech/luna-icons'
import RetailAndLogisticsApi from '../../api/retailAndLogisticsApi'
import FormAlerts from "../Common/FormAlerts";
import { useApiClient } from '../../context/AppContext'
import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal"
import React, { useRef, useState, useEffect } from 'react'
import { FilledButton, OutlinedButton, TextInputField, TextInput } from '@sainsburys-tech/luna-react'
import { RetailAndLogisticsContactModel, RALFilter } from '../../types/Entities/RetailAndLogisticsType'
import { GridWrapper, GridItem, SearchInput, CheckboxField, FormGroup, SelectField } from '@sainsburys-tech/luna-react'


const RetailAndLogistics = () => {
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false)
  const [error, setError] = useState<string | null>(null);
  const [errorAlert, setErrorAlert] = useState<false | string>(false);
  const [successAlert, setSuccessAlert] = useState<false | string>(false);

  const [isOpen, setIsOpen] = useState(false);
  // const [selectedRow, setSelectedRow] = useState('');
  const [selectedIndex, setSelectedIndex] = useState<number>(0)
  const [users, setUsers] = useState([{}])
  const [regions, setRegions] = useState([{}]);
  const [zones, setZones] = useState([{}]);
  const [retailAndLogisticsModel, setRetailAndLogisticsModel] = useState([] as RetailAndLogisticsContactModel[]);
  const [filterRALModel, setFilterRALModel] = useState([] as RetailAndLogisticsContactModel[]);
  const [ralfilter, setRALFilter] = useState({} as RALFilter);
  const apiClient = useApiClient();
  const scrollToTop = () => document.querySelector('div.ln-o-container.content')?.scrollTo(0, 0)

  useEffect(() => {
    const sitemangerdts = async () => {
      setLoader(true);
      loadretailAndLogisticsdts();
      setLoader(false);
    }
    sitemangerdts();
  }, []);

  const loadretailAndLogisticsdts = (): Promise<Array<RetailAndLogisticsContactModel>> => {
    return RetailAndLogisticsApi
      .getallregiondetails(apiClient)
      .then((response) => {
        setRetailAndLogisticsModel(response);
        setFilterRALModel(response);

        const distnames = response.filter(
          (dts: { name: any; }, i: any, arr: any[]) => arr.findIndex((t: { name: any; }) => t.name === dts.name) === i
        );

        const distregion = response.filter(
          (dts: { region: any; }, i: any, arr: any[]) => arr.findIndex((t: { region: any; }) => t.region === dts.region) === i
        );

        const distzone = response.filter(
          (dts: { zone: any; }, i: any, arr: any[]) => arr.findIndex((t: { zone: any; }) => t.zone === dts.zone) === i
        );

        const names = (distnames.filter((x: { role: string; }) => x.role == "DM").map((item: { name: any; }) => ({
          label: item.name,
          value: item.name
        })));

        setUsers(names.sort((a: { label: number; }, b: { label: number; }) => {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        }));

        let regions = (distregion.map((item: { region: any; }) => ({
          label: item.region,
          value: item.region
        })));

        regions = (regions.sort((a: { label: number; }, b: { label: number; }) => {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        }));

        setRegions(regions.filter((x: { label: undefined; }) => x.label != undefined));

        const zones = (distzone.map((item: { zone: any; }) => ({
          label: item.zone,
          value: item.zone
        })))

        setZones(zones.sort((a: { label: number; }, b: { label: number; }) => {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        }));

      })
      .catch(error => {
        console.log(error)
        setErrorAlert('Something went wrong!')
        scrollToTop()
        return error;
      })
  }

  const serachFilter = async () => {

    let sd = ralfilter;
    let data = [...retailAndLogisticsModel];
    if (ralfilter.name) {
      data = data.filter(x => x.name == ralfilter.name);
    }

    if (ralfilter.region) {
      data = data.filter(x => x.region == ralfilter.region);
    }

    if (ralfilter.zone) {
      data = data.filter(x => x.zone == ralfilter.zone);
    }

    setFilterRALModel(data);

  }

  const discardFilter = async () => {
    setRALFilter({
      name: '',
      region: '',
      zone: ''
    })
    setLoader(true);
    loadretailAndLogisticsdts();
    setLoader(false);
  }

  const filterchangeevent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const element = event.target as HTMLSelectElement;

    if (element.id == "UserSelector") {
      setRALFilter(prevFilter => ({
        ...prevFilter,
        name: element.value
      }));
    }
    else if (element.id == "RegionSelector") {
      setRALFilter(prevFilter => ({
        ...prevFilter,
        region: element.value
      }));
    }
    else if (element.id == "ZoneSelector") {
      setRALFilter(prevFilter => ({
        ...prevFilter,
        zone: element.value
      }));
    }

  }

  const clearAlerts = () => {
    setErrorAlert(false);
    setSuccessAlert(false);
  };

  return (
    <>
      <FormAlerts
        showError={errorAlert}
        showSuccess={successAlert}
        onClose={clearAlerts}
      />
      <GridWrapper>
        <GridItem size={{ xs: "1/1", lg: "1/4" }} >
          <div style={{ display: 'contents' }}
            className={"cb-c-alerts-page__filter-container--full-screen"}>
            <GridItem
              size={{ xs: "1/1", sm: "1/1" }}
              className="cb-c-alerts-page__left-panel alerts-page__filter">
              <div className="cb-c-alerts-page__options">
                <div>
                  <div>
                    <GridWrapper>
                      <GridItem size="1/1">
                        <h3>Filter Contacts</h3>
                      </GridItem>
                    </GridWrapper>
                  </div>
                  <FormGroup>
                    <GridWrapper>
                      <GridItem>
                        <SelectField
                          value={ralfilter.name}
                          name="UserSelector"
                          label="Delivery Manager Names"
                          placeholder={"All Delivery Manager"}
                          noResultsMessage="No Delivery Manager found"
                          options={users}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => filterchangeevent(e)}
                        />
                      </GridItem>
                      <GridItem>
                        <SelectField
                          value={ralfilter.region}
                          name="RegionSelector"
                          label="Region"
                          placeholder={"All Regions"}
                          noResultsMessage="No regions found"
                          options={regions}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => filterchangeevent(e)}
                        />
                      </GridItem>
                      <GridItem>
                        <SelectField
                          value={ralfilter.zone}
                          name="ZoneSelector"
                          label="Zone"
                          placeholder={"All Zones"}
                          noResultsMessage="No zones found"
                          options={zones}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => filterchangeevent(e)}
                        />
                      </GridItem>
                    </GridWrapper>
                  </FormGroup>
                  <>
                    <GridItem size={{ xl: '1', ss: '1', default: '1/1' }} className='formInputMaxWidth'>
                      <div className='formButtonGroup'>
                        <OutlinedButton size='200px' className='formDiscardButton' onClick={discardFilter} >Discard</OutlinedButton>
                        <FilledButton size='200px' onScroll={scrollToTop} onClick={serachFilter} className='formSaveButton' >Search</FilledButton>
                      </div>
                    </GridItem>
                  </>

                </div>
              </div>
            </GridItem>
          </div>
        </GridItem>
        <GridItem
          className={"cb-c-alerts-page__right-panel"}
          size={{ xs: "1/1", lg: "3/4" }}>

          {
            (loader === true) && (<div className='loader'></div>)
          }
          <div className='scm_contacts_table'>
            <table style={{ margin: "10px" }} className="linkedworkorder" >
              <tbody >
                <tr>
                  <th>Region</th>
                  <th>Zone</th>
                  <th>Type</th>
                  <th>Area</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                </tr>
                {
                  filterRALModel && filterRALModel.length > 0 &&
                  filterRALModel.map((scmdetails, index) => (

                    <tr key={index}>
                      {/* <td onClick={() => { setIsOpen(true); setSelectedIndex(index); }}>{!( index > 0 && scmdetails.region === filterRALModel[index - 1].region) ?  scmdetails.region : ""}</td>

                      <td onClick={() => { setIsOpen(true); setSelectedIndex(index); }}>{!( index > 0 && scmdetails.region === filterRALModel[index - 1].region) ?  scmdetails.zone : ""}</td> */}
                      <td onClick={() => { setIsOpen(true); setSelectedIndex(index); }}>{scmdetails.region}</td>

                      <td onClick={() => { setIsOpen(true); setSelectedIndex(index); }}>{scmdetails.zone}</td>

                      <td>{scmdetails.dmType ? scmdetails.dmType : "All"}</td>

                      <td>{scmdetails.dmArea ? scmdetails.dmArea : ""}</td>

                      <td>{scmdetails.name ? scmdetails.name : "Not Set"}</td>

                      <td>{scmdetails.phone ? scmdetails.phone : "Not Set"}</td>

                      <td>{scmdetails.email ? scmdetails.email : "Not Set"}</td>

                      {/* <td>{scmdetails.notes}</td> */}

                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

        </GridItem>
      </GridWrapper>

      {
        retailAndLogisticsModel && retailAndLogisticsModel.length > 0 &&
        <Modal small={true} alert hideCloseButton open={isOpen} headingId="dialog-modal" style={{ display: 'flow', alignContent: "center", textAlign: '-webkit-center' }}>
          <div>
            <GridItem size="1" className="ln-u-hard" >
              <div>
                {/* <b>Zone : {selectedRow ? selectedRow : ' '}</b><br /> */}
                <b>Zone : {selectedIndex >= 0 && filterRALModel[selectedIndex] ? filterRALModel[selectedIndex].zone : ""}</b><br />
                <b>Head of FM : {selectedIndex >= 0 && filterRALModel[selectedIndex] ? filterRALModel[selectedIndex].lscmUser.name : ""}</b><br />
                <b>Phone : {selectedIndex >= 0 && filterRALModel[selectedIndex] ? filterRALModel[selectedIndex].lscmUser.phone : ""}</b><br />
                <b>Email : {selectedIndex >= 0 && filterRALModel[selectedIndex] ? filterRALModel[selectedIndex].lscmUser.email : ""}</b><br /><br/>
                <b>FM Business Partner : {selectedIndex >= 0 && filterRALModel[selectedIndex] ? filterRALModel[selectedIndex].scmUser.name : ""}</b><br />
                <b>Phone : {selectedIndex >= 0 && filterRALModel[selectedIndex] ? filterRALModel[selectedIndex].scmUser.phone : ""}</b><br />
                <b>Email : {selectedIndex >= 0 && filterRALModel[selectedIndex] ? filterRALModel[selectedIndex].scmUser.email : ""}</b><br />
              </div>
            </GridItem>
            <FilledButton style={{ float: 'right' }}
              onClick={() => setIsOpen(false)}>
              Close
    </FilledButton>
          </div>
        </Modal>
      }

    </>
  );
};

export default RetailAndLogistics;

